import { setDiameterStatus, setSteelTypes, addSteelDiameters, addAdminSteelDiameters, removeAdminSteelType, updateSteelTypeIns } from "Redux/features/steelType";
import { AppThunk } from 'Redux/store';
import { isAxiosResponse } from "Services/index";
import { deleteSteelType, getSteelDiameters, getSteelTypes, updateSteelType } from "Services/steelType";

export const fetchSteelTypes = (): AppThunk => async dispatch => {
  const response = await getSteelTypes();
  if (isAxiosResponse(response)) {
    await dispatch(setSteelTypes(response.data.results));
  }
}

const diameterRequests: Record<number, Promise<any[]>> = {};

export const fetchSteelDiameters = (steelID: number, next = (val: any[]) => {}): AppThunk => async (dispatch, getState) => {
  const cached = getState().steelType.steelDiameters;
  if (steelID in cached) {
    next(cached[steelID]);
    return;
  }
  dispatch(setDiameterStatus({ id: steelID, status: "loading" }));
  try {
    if (!diameterRequests[steelID]) {
      diameterRequests[steelID] = getSteelDiameters(steelID).then(response => {
        if (!isAxiosResponse(response) || !Array.isArray(response.data)) {
          throw new Error("Invalid diameter response");
        }
        return [...response.data].sort((a: any, b: any) => a.steel_diameter - b.steel_diameter);
      });
    }
    const diameters = await diameterRequests[steelID];
    dispatch(addSteelDiameters({ steelID, steelDiameters: diameters }));
    dispatch(setDiameterStatus({ id: steelID, status: "success" }));
    next(diameters);
  } catch (_err) {
    dispatch(setDiameterStatus({ id: steelID, status: "error" }));
  } finally {
    delete diameterRequests[steelID];
  }
};

export const fetchAdminSteelDiameters = (steelID: number): AppThunk => async (dispatch, getState) => {
  try {
    const response = await getSteelDiameters(steelID);
    if (isAxiosResponse(response)) {
      await dispatch(addAdminSteelDiameters(response.data));
    }
  } catch (err) {
    console.log(err);
  }
}

export const removeSteelType = (steelTypeID: number): AppThunk => async dispatch => {
  const response = await deleteSteelType(steelTypeID);
  if (isAxiosResponse(response)) {
    await dispatch(removeAdminSteelType(steelTypeID));
  }
}

export const updateSteelTypeName = (steelTypeID: number, data: any): AppThunk => async dispatch => {
  const response = await updateSteelType(steelTypeID, data);
  if (isAxiosResponse(response)) {
    await dispatch(updateSteelTypeIns(response.data));
  }
}
